import cn from "classnames";
import MPOzonIcon from "@assets/icons/marketplace-ozon.svg";
import MPWbIcon from "@assets/icons/marketplace-wb.svg";
import MPYandexIcon from "@assets/icons/marketplace-yandex.svg";
import MPAliExpressIcon from "@assets/icons/marketplace-aliexpress.svg";
import styles from './MarketplaceIcon.module.css';

interface MarketplaceIconProps {
  marketplace?: string;
  className?: string;
}

function getMarketplaceData(id: string): string {
  const icons: Record<string, string> = {
    Ozon: MPOzonIcon,
    Yandex: MPYandexIcon,
    Wildberries: MPWbIcon,
    Aliexpress: MPAliExpressIcon,
  }

  return icons[id] ?? "";
}

const MarketplaceIcon: React.FC<MarketplaceIconProps> = ({
  marketplace,
  className,
}) => {
  const icon = getMarketplaceData(marketplace ?? "");

  if (!icon) return null;

  return (
    <img
      className={cn(className, styles.icon)}
      src={icon}
      alt=""
    />
  );
};

export default MarketplaceIcon;
